import { Component, OnInit, Input, ViewEncapsulation, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
    selector: 'app-modal-basic',
    templateUrl: './modal-basic.component.html',
    styleUrls: [ './modal-basic.component.scss' ],
    encapsulation: ViewEncapsulation.None
})
export class ModalBasicComponent implements OnInit {
    @Input() dialogClass: string;
    @Input() hideHeader = false;
    @Input() hideFooter = false;
    @Input() maxWidth = '500px';
    @Input() alignSelfModal = 'auto';
    @Input() padding = '16px';
    @Input()
    set display(value: boolean) {
        value ? this.show() : this.hide();
        this.displayChange.emit(value);
    }

    @Output() displayChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    public visible = false;
    public visibleAnimate = false;

    constructor() {}

    ngOnInit() {}

    public show(): void {
        this.visible = true;
        document.body.style.overflowY = 'hidden';
        setTimeout(() => (this.visibleAnimate = true), 100);
    }

    public hide(): void {
        this.visibleAnimate = false;
        document.body.style.overflowY = 'auto';
        setTimeout(() => (this.visible = false), 300);
    }

    public onContainerClicked(event: MouseEvent): void {
        if ((<HTMLElement>event.target).classList.contains('modal')) {
            this.hide();
            this.display = false;
        }
    }
}
